import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
    standalone: true,
})
export class LoaderComponent {
    color = input<string>('#FFF');
    size = input<string>('3rem');
    borderWidth = input<string>('0.25rem');

    innerSize = computed(() => `calc(${this.size()} - ${this.borderWidth()})`);

    border = computed(() => `${this.borderWidth()} solid ${this.color()}`);
    borderColor = computed(
        () => `${this.color()} transparent transparent transparent`
    );

    loop = [null, null, null, null];
}
